if (!customElements.get('product-card-form')) {
  customElements.define(
    'product-card-form',
    class ProductCardForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitText = this.querySelector('[data-pcard-atc-text]');
        this.card = this.closest('.product-card');
        this.variants = this.getVariants();

        this.addEventListener('change', this.onVariantChange.bind(this));
        this.updateFromSelection();
      }

      getVariants() {
        const script = this.querySelector('[data-pcard-variants]');
        if (!script) return [];

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error(error);
          return [];
        }
      }

      getSelectedOptions() {
        return Array.from(this.querySelectorAll('.product-card__variant-option')).map((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      getCurrentVariant() {
        const options = this.getSelectedOptions();
        if (!options.length) {
          return this.variants.find((variant) => variant.id === Number(this.variantInput?.value)) || this.variants[0];
        }

        return this.variants.find((variant) =>
          Array.isArray(variant.options) && variant.options.every((option, index) => option === options[index])
        );
      }

      onVariantChange() {
        this.updateFromSelection();
      }

      updateFromSelection() {
        const variant = this.getCurrentVariant();

        if (!variant || !this.variantInput) {
          if (this.submitButton) this.submitButton.setAttribute('disabled', 'disabled');
          if (this.submitText) this.submitText.textContent = FoxTheme.variantStrings.unavailable;
          return;
        }

        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;

        if (this.submitButton) {
          if (variant.available) {
            this.submitButton.removeAttribute('disabled');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
        }

        if (this.submitText) {
          this.submitText.textContent = variant.available
            ? FoxTheme.variantStrings.addToCart
            : FoxTheme.variantStrings.soldOut;
        }

        this.updatePrice(variant);
        this.updateMedia(variant);
      }

      updatePrice(variant) {
        if (!this.card || !window.FoxTheme?.Currency) return;

        const priceContainer = this.card.querySelector('.f-price');
        if (!priceContainer) return;

        const moneyFormat = FoxTheme.settings.moneyFormat;
        const price = FoxTheme.Currency.formatMoney(variant.price, moneyFormat);
        const compareAtPrice = variant.compare_at_price
          ? FoxTheme.Currency.formatMoney(variant.compare_at_price, moneyFormat)
          : null;
        const onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);

        priceContainer.classList.toggle('f-price--on-sale', onSale);
        priceContainer.classList.toggle('f-price--sold-out', !variant.available);

        const regularPrice = priceContainer.querySelector('.f-price__regular .f-price-item--regular');
        const salePrice = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
        const saleCompare = priceContainer.querySelector('.f-price__sale .f-price-item--regular');

        if (onSale) {
          if (salePrice) salePrice.innerHTML = price;
          if (saleCompare) saleCompare.innerHTML = `<s>${compareAtPrice}</s>`;
          if (regularPrice) regularPrice.innerHTML = '';
        } else {
          if (regularPrice) regularPrice.innerHTML = price;
          if (salePrice) salePrice.innerHTML = '';
          if (saleCompare) saleCompare.innerHTML = '';
        }
      }

      updateMedia(variant) {
        if (!this.card || !variant.featured_media_id) return;

        const media = this.card.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
        if (!media) return;

        const mainImage = this.card.querySelector('.product-card__image--main img, .product-card__image img');
        const sourceImage = media.tagName === 'IMG' ? media : media.querySelector('img');
        if (!mainImage || !sourceImage) return;

        if (sourceImage.src) mainImage.src = sourceImage.src;
        if (sourceImage.srcset) mainImage.srcset = sourceImage.srcset;
      }
    }
  );
}
